import { ArrowDownTrayIcon } from '@heroicons/react/24/outline';
import { Box, styled, Typography } from '@mui/material';

export const BoxDownloadStyled = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.dark.dark_6,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: theme.spacing(2),
  borderRadius: theme.spacing(2),
}));

export const BadgeFileStyled = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.dark.dark_5,
  borderRadius: '50%',
  width: theme.typography.pxToRem(48),
  height: theme.typography.pxToRem(48),
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}));

export const TypoDownloadStyled = styled(Typography)(({ theme }) => ({
  color: theme.palette.dark.dark_2,
  display: 'flex',
  alignItems: 'center',
}));

export const DownloadIconStyled = styled(ArrowDownTrayIcon)(({ theme }) => ({
  cursor: 'pointer',
  color: theme.palette.white.main,
}));
